import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import portalAdminService from '../../services/portalAdminService';
import { profileService } from '../../services';
import { useAuth, useDialog } from '../../context';
import PortalShell from './PortalShell';

export default function PortalAdminMemberDetailPage() {
  const { userId } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const { showConfirm } = useDialog();
  const [member, setMember] = useState(null);
  const [resume, setResume] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const isOwner = user?.portalRole === 'owner';

  useEffect(() => {
    portalAdminService.getMember(userId).then(async (r) => {
      if (r.success) setMember(r.data);
      const p = await profileService.getProfileByUserId(userId);
      if (p.success) setResume(p.data);
    });
  }, [userId]);

  const remove = async () => {
    const ok = await showConfirm({ title: 'Remove from Portal Noir', message: `Remove ${member?.displayName} from Portal Noir? Their existing chats stay; future access does not.`, confirmLabel: 'REMOVE', variant: 'danger' });
    if (!ok) return;
    setBusy(true); setError(null);
    const r = await portalAdminService.removeMember(userId);
    setBusy(false);
    if (r.success) navigate('/noir/admin/members', { replace: true });
    else setError(r.error || 'Could not remove');
  };

  const promote = async () => {
    setBusy(true); setError(null);
    const r = await portalAdminService.promoteAdmin(userId);
    setBusy(false);
    if (r.success) {
      const refreshed = await portalAdminService.getMember(userId);
      if (refreshed.success) setMember(refreshed.data);
    } else setError(r.error || 'Could not promote');
  };

  const demote = async () => {
    setBusy(true); setError(null);
    const r = await portalAdminService.demoteAdmin(userId);
    setBusy(false);
    if (r.success) {
      const refreshed = await portalAdminService.getMember(userId);
      if (refreshed.success) setMember(refreshed.data);
    } else setError(r.error || 'Could not demote');
  };

  return (
    <PortalShell viewerState="accepted">
      <div style={{ maxWidth: 980, margin: '24px auto 80px', padding: '0 24px' }}>
        <button onClick={() => navigate('/noir/admin/members')} className="portal-mono" style={{ background: 'none', border: 'none', color: 'rgba(236,231,218,0.34)', cursor: 'pointer', fontSize: 11, marginBottom: 24 }}>← MEMBERS</button>

        <p className="portal-label" style={{ marginBottom: 14 }}>MEMBER</p>
        <h1 className="portal-hero" style={{ marginBottom: 28 }}>{member?.displayName || '…'}</h1>

        {error && <p className="portal-mono" style={{ color: '#B4736A' }}>{error}</p>}

        <div className="portal-grid-sidebar">
          <div>
            <p className="portal-label" style={{ marginBottom: 12 }}>PORTAL NOIR</p>
            <div className="portal-card" style={{ padding: 20 }}>
              <div style={{ display: 'flex', gap: 16, marginBottom: 16 }}>
                <div className="portal-avatar" style={{ width: 80, height: 80 }}>
                  {resume?.avatarUrl || resume?.faceUrl ? <img src={resume.avatarUrl || resume.faceUrl} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : null}
                </div>
                <div>
                  <div className="portal-serif" style={{ fontSize: 20 }}>{resume?.displayName || member?.displayName}</div>
                  <div className="portal-mono" style={{ fontSize: 10, color: 'rgba(236,231,218,0.34)' }}>
                    {resume?.handle ? `@${resume.handle}` : ''}{resume?.location ? ` · ${resume.location.toUpperCase()}` : ''}
                  </div>
                </div>
              </div>
              {resume?.vibeCheck && (
                <p className="portal-serif" style={{ fontStyle: 'italic', color: 'rgba(236,231,218,0.56)' }}>"{resume.vibeCheck}"</p>
              )}
            </div>
          </div>

          <div>
            <p className="portal-label" style={{ marginBottom: 12 }}>ROLE</p>
            <div className="portal-card" style={{ padding: 14, marginBottom: 14 }}>
              <span className="portal-chip">{(member?.portalRole || 'MEMBER').toUpperCase()}</span>
            </div>

            <p className="portal-label" style={{ marginBottom: 12 }}>ACTIONS</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {isOwner && member?.portalRole === 'member' && (
                <button onClick={promote} className="portal-btn solid" disabled={busy}>PROMOTE TO ADMIN</button>
              )}
              {isOwner && member?.portalRole === 'admin' && (
                <button onClick={demote} className="portal-btn ghost" disabled={busy}>DEMOTE TO MEMBER</button>
              )}
              {member?.portalRole !== 'owner' && (
                <button onClick={remove} className="portal-btn danger" disabled={busy}>REMOVE FROM PORTAL NOIR</button>
              )}
            </div>
          </div>
        </div>
      </div>
    </PortalShell>
  );
}
